import styled from 'styled-components'
import { Link } from 'react-router-dom'
import {
  LEGACY_BREAKPOINT_QUERIES,
  createResponsiveBreakpointQuery
} from 'styles/breakpoints'

const desktopQuery = createResponsiveBreakpointQuery('desktopUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.searchDesktopUp
})

export const ContentWrapper = styled.div`
  position: relative;
  flex: 1 1 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

export const ScrollContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  transition: opacity 150ms ease-in-out, visibility 150ms ease-in-out;
  opacity: ${(p) => (p.$hidden ? 0 : 1)};
  visibility: ${(p) => (p.$hidden ? 'hidden' : 'visible')};

  :root[data-new-playbar='true'] & {
    padding-bottom: var(--playbar-content-bottom-offset, 140px);
  }
`

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
`

// Mobile-only: sticky container for the Tabs bar below the search bar
export const MobileTabsContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
  background: ${({ theme }) => theme.colors.neutralW10};
  padding: 12px 16px 8px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutralW20};
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3rem; /* mt-12 */
  padding: 0 2.5rem; /* px-10 */
  flex-grow: 1;
`

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3rem; /* h-12 */
  position: relative;
`

export const SectionTitle = styled.p`
  font-size: 1.875rem; /* text-3xl */
  color: #ffffff;
  user-select: none;
  margin: 0;
`

export const SeeAllLink = styled(Link)`
  color: ${({ theme }) => theme.colors.neutralW70};
  font-size: 0.875rem; /* text-sm */
  text-transform: uppercase;
  text-decoration: none;
`

export const Cells = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  align-content: flex-start;
`

export const HalfCell = styled.div`
  width: 50%;
  margin-top: 2rem; /* mt-8 */
  box-sizing: border-box;
  padding-right: 0.5rem;
`

export const InlineCell = styled.div`
  display: inline-block;
  margin-right: 2.5rem; /* mr-10 */
`

export const PageBody = styled.div`
  padding-bottom: 2rem; /* pb-8 */
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
`

export const TopRow = styled.div`
  display: flex;
  flex-direction: column;

  @media ${desktopQuery} {
    flex-direction: row; /* xl:flex-row */
  }
`

export const TopTitle = styled.div`
  border-left: 3px solid #0ea5b9; /* cerulean-ish */
  padding-left: 1rem; /* pl-4 */
  color: #ffffff;
  font-size: 1.875rem; /* text-3xl */
  height: 2rem; /* h-8 */
  display: flex;
  align-items: center;
  margin: 1.5rem 1rem; /* my-6 */
  margin-left: 3rem; /* ml-12 */

  @media ${desktopQuery} {
    margin-top: 6rem; /* xl:my-24 */
    margin-bottom: 6rem;
    width: auto;
    flex: none;
  }
`

export const TitleContent = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`

export const TitleIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

export const TopGrid = styled.div`
  height: 16rem; /* h-64 */
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  overflow: hidden;
`

// Mobile-only list for Top Results
export const MobileTopList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 12px 16px;
`

export const CategoriesWrap = styled.div`
  margin-left: 1rem; /* ml-4 */
  width: 92%; /* w-11/12 */
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  justify-content: center;

  @media ${desktopQuery} {
    justify-content: flex-start; /* xl:justify-start */
  }
`

export const NoResultsWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10rem auto 0; /* mt-40 */
  padding: 0 16px;
`

export const GridColumn = styled.div`
  display: inline-block;
  padding: 0 1.5rem; /* px-6 */
  flex: 1 1 auto;
  margin: 0 auto;
`

export const SeeAllContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 2rem; /* px-8 */
`

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 24px;
`

export const IconCircle = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  justify-items: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.player20};
`
